@use "../../styles/variables" as vars;

.success {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: clamp(40px, 5vw, 64px) clamp(26px, 3vw, 40px) clamp(48px, 6vw, 80px);
  background: vars.$color-page;
}

.layout {
  width: min(100%, 600px);
}

.heading {
  margin-bottom: 18px;
  text-align: center;

  h1 {
    margin: 0 0 14px;
    color: vars.$color-primary;
    font-family: vars.$font-heavy;
    font-size: clamp(28px, 2.6vw, 34px);
    line-height: 1.1;
    white-space: nowrap;
  }

  p {
    margin: 0;
    color: vars.$color-muted;
    font-size: 17px;
    line-height: 1.4;
  }

  strong {
    font-family: vars.$font-heavy;
  }
}

.card {
  display: grid;
  width: min(100%, 470px);
  margin: 0 auto;
  justify-items: center;
  gap: 24px;
  padding: clamp(22px, 3vw, 30px) clamp(16px, 2.5vw, 24px);
  border-radius: vars.$radius-md;
  background: vars.$color-surface;
  box-shadow: 0 8px 32px rgb(0 0 0 / 10%);
}

.countdown {
  display: grid;
  gap: 20px;
  text-align: center;

  h2 {
    margin: 0;
    color: vars.$color-primary;
    font-family: vars.$font-heavy;
    font-size: 22px;
  }

  > p {
    margin: 0;
    color: vars.$color-primary;
    font-family: vars.$font-heavy;
    font-size: clamp(16px, 1.5vw, 19px);
    line-height: 1.3;
  }
}

.values {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: start;

  div {
    position: relative;
    display: grid;
    min-width: 0;
    gap: 5px;

    &:not(:last-child)::after {
      position: absolute;
      top: -2px;
      right: -4px;
      color: vars.$color-text;
      content: ":";
      font-family: vars.$font-heavy;
      font-size: 30px;
      line-height: 1;
    }
  }

  strong {
    color: vars.$color-text;
    font-family: vars.$font-heavy;
    font-size: clamp(30px, 3.4vw, 42px);
    font-variant-numeric: tabular-nums;
    line-height: 1;
  }

  span {
    color: vars.$color-muted;
    font-size: 13px;
  }
}

.backButton {
  width: 130px;
  min-height: 38px;
  padding: 7px 18px;
  border: 0;
  border-radius: vars.$radius-sm;
  background: #a6a6a6;
  color: #fff;
  cursor: pointer;
  font-family: vars.$font-heavy;
  font-size: 16px;
  transition: filter 0.2s ease;

  &:hover {
    filter: brightness(0.96);
  }

  &:active {
    filter: brightness(0.92);
  }
}

@media (max-width: 520px) {
  .success {
    min-height: auto;
    padding: 36px 10px;
  }

  .card {
    padding: 22px 12px;
  }

  .heading {
    h1 {
      font-size: clamp(16px, 5.5vw, 22px);
    }

    p {
      font-size: 15px;
    }
  }

  .values {
    strong {
      font-size: clamp(27px, 9vw, 36px);
    }

    div:not(:last-child)::after {
      right: -3px;
      font-size: 26px;
    }

    span {
      font-size: 12px;
    }
  }
}

@media (min-width: 1081px) {
  .heading {
    h1 {
      font-size: clamp(23px, 2.07vw, 27px);
    }

    p {
      font-size: 14px;
    }
  }

  .countdown {
    h2 {
      font-size: 18px;
    }

    > p {
      font-size: clamp(13px, 1.2vw, 15px);
    }
  }

  .values span {
    font-size: 11px;
  }

  .backButton {
    font-size: 13px;
  }
}

@media (max-width: 600px) {
  .heading {
    h1 {
      font-size: clamp(16px, 5.5vw, 22px);
    }

    p {
      font-size: 14px;
    }
  }

  .countdown {
    h2 {
      font-size: 20px;
    }

    > p {
      font-size: 15px;
    }
  }

  .values span {
    font-size: 10px;
  }

  .backButton {
    font-size: 14px;
  }
}
